import Vue from 'vue'
import Router from "vue-router"
// import { auth } from "firebase"
import UserAuth from '../auth/js/index'

import Body from '../components/body'
import Auth from '../auth/auth'

import Home from '../pages/home'
import Profile from '../pages/profile'
import Watchlist from '../pages/watchlist'
import Trades from '../pages/trades'
import Setting from '../pages/setting'
import Process from '../pages/process'

/* Dashboard */
// import Dashboard from '../pages/dashboard'
import DashboardStock from '../pages/dashboard/stock'
import DashboardForex from '../pages/dashboard/forex'
import DashboardCommodity from '../pages/dashboard/commodity'

/* Stock */
import StockHome from '../pages/stock'
import StockToday from '../pages/stock/today'
/* Stock Board */
import StockBoard from '../pages/stock/board'
import StockIndices from '../pages/stock/indices'
/* Stock Industry */
import StockIndustry from '../pages/stock/industry'
/* Stock Ticker */
import StockTicker from '../pages/stock/ticker'
import StockHistorical from '../pages/stock/historical'
import StockIntraday from '../pages/stock/intraday'
import StockProgress from '../pages/stock/progress'
import StockMatch from '../pages/stock/match'
/* Stock Multi */
import StockMultiH1Volatility from '../pages/stock/multi/h1_volatility'
/* Stock Scan */
import StockScan from '../pages/stock/scan'
import StockScanHL5 from '../pages/stock/scan/hl5'
import StockScanHL10 from '../pages/stock/scan/hl10'
import StockScanUptrend from '../pages/stock/scan/uptrend'
import StockScanTradePotential from '../pages/stock/scan/trade_potential'
import StockScanVolatileQuarter from '../pages/stock/scan/volatile_quarter'
/* Stock Simulate */
import StockSimulate from '../pages/stock/simulate'
import StockSimulateHL from '../pages/stock/simulate/hl'
/* Stock Status */
import StockStatus from '../pages/stock/status'
/* File Manager  */
import FileManager from '../pages/filemanager'

import Pricing from '../pages/pricing'

/* Auth */
import Login from '../auth/login'
import Register from '../auth/register'
import Callback from '../pages/callback'

/* Error */
import Maintenance from '../pages/maintenance'
import Error400 from '../errors/error_400'
import Error401 from '../errors/error_401'
import Error403 from '../errors/error_403'
import Error404 from '../errors/error_404'
import Error500 from '../errors/error_500'
import Error503 from '../errors/error_503'
import ComingSoon from '../pages/comingsoon'

import moment from 'moment'

// component

Vue.use(Router)

const routes = [
  { path: '', redirect: { name: 'home' }},
  {
    path: '',
    component: Body,
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: {
          title: 'Home | Trade Winds',
        }
      },
      {
        path: 'watchlist',
        name: 'watchlist',
        component: Watchlist,
        meta: {
          title: 'Watchlist',
        }
      },
      {
        path: 'trades',
        name: 'trades',
        component: Trades,
        meta: {
          title: 'Trades',
        }
      },
      {
        path: 'process',
        name: 'process',
        component: Process,
        meta: {
          title: 'Processes',
        }
      },
      {
        path: 'file-manager',
        name: 'file-manager',
        component: FileManager,
        meta: {
          title: 'File Manager',
        }
      },
      {
        path: 'pricing',
        name: 'pricing',
        component: Pricing,
        meta: {
          title: 'Pricing',
        }
      },
      {
        path: 'setting',
        name: 'setting',
        component: Setting,
        meta: {
          title: 'Setting',
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: Profile,
        meta: {
          title: 'Profile',
        }
      }
    ]
  },
  {
    path: '/dashboard',
    component: Body,
    children: [
      {
        path: 'stock',
        name: 'dashboard-stock',
        component: DashboardStock,
        meta: {
          title: 'Stock Dashboard',
        }
      },
      {
        path: 'forex',
        name: 'dashboard-forex',
        component: DashboardForex,
        meta: {
          title: 'Forex Dashboard',
        }
      },
      {
        path: 'commodity',
        name: 'dashboard-commodity',
        component: DashboardCommodity,
        meta: {
          title: 'Commodity Dashboard',
        }
      },
    ]
  },
  {
    path: '/stock',
    component: Body,
    children: [
      {
        path: '',
        name: 'stock-home',
        component: StockHome,
        meta: {
          title: 'Stock Home',
        }
      },
      {
        path: 'board',
        redirect: {  path: '/stock/board/main' }
      },
      {
        path: 'board/:board',
        name: 'stock-board',
        component: StockBoard,
        meta: {
          title: 'Stock Board',
        }
      },
      {
        path: 'industry',
        name: 'stock-industry',
        component: StockIndustry,
        meta: {
          title: 'Stock Industry',
        }
      },
      {
        path: 'ticker',
        name: 'stock-ticker',
        component: StockTicker,
        meta: {
          title: 'Stock Ticker',
        }
      },
      {
        path: 'ticker/:ticker',
        name: 'stock-historical',
        component: StockHistorical,
        meta: {
          title: 'Stock Historical',
        }
      },
      { path: 'ticker/:ticker/date', redirect: { path: 'ticker/:ticker/date/'+moment().format('YYYY-MM-DD') }},
      // {
      //   path: 'ticker/:ticker/date',
      //   name: 'stock-intraday',
      //   component: StockIntraday,
      //   meta: {
      //     title: 'Stock Intraday',
      //   }
      // },
      {
        path: 'ticker/:ticker/date/:date',
        name: 'stock-intraday-date',
        component: StockIntraday,
        meta: {
          title: 'Stock Intraday',
        }
      },
      {
        path: 'indices',
        name: 'stock-indices',
        component: StockIndices,
        meta: {
          title: 'Stock Indices',
        }
      },
      {
        path: 'today',
        name: 'stock-today',
        component: StockToday,
        meta: {
          title: 'Stock Today',
        }
      },
      {
        path: 'progress',
        name: 'stock-progress',
        component: StockProgress,
        meta: {
          title: 'Stock Progress',
        }
      },
      {
        path: 'scan',
        name: 'stock-scan',
        component: StockScan,
        meta: {
          title: 'Stock Scan',
        }
      },
      {
        path: 'scan/hl5',
        name: 'stock-scan-hl5',
        component: StockScanHL5,
        meta: {
          title: 'High Low 5',
        }
      },
      {
        path: 'scan/hl10',
        name: 'stock-scan-hl10',
        component: StockScanHL10,
        meta: {
          title: 'High Low 10',
        }
      },
      {
        path: 'scan/uptrend',
        name: 'stock-scan-uptrend',
        component: StockScanUptrend,
        meta: {
          title: 'Uptrend Stocks',
        }
      },
      {
        path: 'scan/trade_potential',
        name: 'stock-scan-trade',
        component: StockScanTradePotential,
        meta: {
          title: 'Trade Potential',
        }
      },
      {
        path: 'scan/h1_volatility',
        name: 'scan-h1_volatility',
        component: StockMultiH1Volatility,
        meta: {
          title: 'Hourly Volatility',
        }
      },
      {
        path: 'scan/volatile_quarter',
        name: 'stock-scan-volatile-quarter',
        component: StockScanVolatileQuarter,
        meta: {
          title: 'Volatile Quarter',
        }
      },

      {
        path: 'simulate',
        name: 'stock-simulate',
        component: StockSimulate,
        meta: {
          title: 'Stock Simulate',
        }
      },
      {
        path: 'simulate/hl',
        redirect: { path: 'simulate/hl/EDARAN/2021-10-01' }
      },
      {
        path: 'simulate/hl/:ticker/:start_date',
        name: 'stock-simulate-hl',
        component: StockSimulateHL,
        meta: {
          title: 'High Low Simulator',
        }
      },
      {
        path: 'simulate/hl/:ticker/:start_date/:end_date',
        name: 'stock-simulate-hl-e',
        component: StockSimulateHL,
        meta: {
          title: 'High Low Simulator',
        }
      },
      {
        path: 'status',
        name: 'stock-status',
        component: StockStatus,
        meta: {
          title: 'Stock Status',
        }
      },
      {
        path: ':match',
        name: 'stock-match',
        component: StockMatch,
        meta: {
          title: 'Stock Match',
        }
      },
    ]
  },
  {
    path: '/',
    component: Auth,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          title: 'Login',
        }
      },
      {
        path: 'register',
        name: 'register',
        component: Register,
        meta: {
          title: ' Register',
        }
      }
    ]
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback,
    meta: {
      title: 'Auth0',
    }
  },
  {
    path:'/error-400',
    name:'Error400',
    component:Error400,
    meta: {
      title: 'Error 400',
    }
  },
  {
    path:'/error-401',
    name:'Error401',
    component:Error401,
    meta: {
      title: 'Error 401',
    }
  },
  {
    path:'/error-403',
    name:'Error403',
    component:Error403,
    meta: {
      title: 'Error 403',
    }
  },
  {
    path:'/error-404',
    name:'Error404',
    component:Error404,
    meta: {
      title: 'Error 404',
    }
  },
  {
    path:'/error-500',
    name:'Error500',
    component:Error500,
    meta: {
      title: 'Error 500',
    }
  },
  {
    path:'/error-503',
    name:'Error503',
    component:Error503,
    meta: {
      title: 'Error 503',
    }
  },
  {
    path:'/maintenance',
    name:'Maintenance',
    component:Maintenance,
    meta: {
      title: 'Maintenance',
    }
  },
  {
    path:'/coming-soon',
    name:'ComingSoon',
    component:ComingSoon,
    meta: {
      title: 'Coming Soon',
    }
  },
  {
    path: '*',
    redirect: { path:'/error-404' }
  },
  ];

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  if(to.meta.title) document.title = to.meta.title
  let accessToken = localStorage.getItem('accessToken')
  const CurrentUser = UserAuth.userProfile
  const path = ['/login','/register']
  if (path.includes(to.path) || to.path === '/callback' || CurrentUser || UserAuth.isAuthenticatedUser() || accessToken){
    return next();
  }
  next('/login')
})

// router.beforeEach((to, from, next) => {
//   auth().onAuthStateChanged(() => {
//     if(to.meta.title)
//       document.title = to.meta.title;
//     const CurrentUser = firebase.auth().currentUser;
//     const  path = ['/auth/login','/auth/register'];
//     if (path.includes(to.path) || to.path === '/callback' || CurrentUser || UserAuth.isAuthenticatedUser()){
//       return next();
//     }
//     next('/auth/login');
//   });
// });

export default router
